import { PropertiesEntity } from '../../../../api/fetchSymDiaProperties';

export const generateOptionsFunc = (
    properties: PropertiesEntity[],
): ((
    value: string,
) => { id: string; label: string; value: string; meta: { id: string; unit: string } }[]) => {
    return (value) => {
        if (!value) {
            return [];
        }
        let pureInputValue = value.trim();

        properties.forEach((p) => {
            const index = pureInputValue.toLowerCase().indexOf(p.name.toLowerCase());

            if (index > -1) {
                pureInputValue = pureInputValue.substr(0, index).trim();
            }
        });

        return properties.map((pg) => {
            const unit = parseInt(pureInputValue) > 1 && pg.name_p ? pg.name_p : pg.name;
            return {
                id: pg.id,
                label: `${pureInputValue} ${unit}`,
                value: pureInputValue,
                meta: {
                    // TODO clean up
                    id: pg.id,
                    unit: unit,
                },
            };
        });
    };
};
